import React from 'react'
import { Block, Card, cssRules, ThemeVariants, Typography } from 'rds'

const CheckoutFormCardSection = ({ error, children, className }) => {
    return (
        <div className={`rds-full-block ${className || ''}`}>
            {error ? (
                <Block
                    className='checkout-form_card-section_error rds-full-block rds-p_around__sm rds-p_left__md rds-p_right__md rds-flex rds-align-center'
                    style={{
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    }}
                    roundedBorder
                    bordered
                >
                    {error
                        ? error.split('\n').map((error, index) => (
                              <Typography
                                  key={index}
                                  variant={ThemeVariants.WHITE}
                              >
                                  {error}
                              </Typography>
                          ))
                        : null}
                </Block>
            ) : null}
            <Card
                variant={ThemeVariants.WHITE}
                className='checkout-form_card-section_inner rds-full-block rds-m_bottom__sm'
                style={{
                    borderTop: error ? 0 : null,
                    borderTopLeftRadius: error ? 0 : null,
                    borderTopRightRadius: error ? 0 : null,
                    borderColor: error
                        ? cssRules.getCSSVariable('colorError')
                        : null,
                }}
            >
                {children}
            </Card>
        </div>
    )
}

export default CheckoutFormCardSection
